var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('ComponentResolver',{key:"TrackerDataTableItemEdit",attrs:{"componentId":"TrackerDataTableItemEdit","componentProps":{
                        api: _vm.computeApi,
                        configuration: _vm.dataTableConfiguration,
                        mode: _vm.mode,
                        propTitle: _vm.computeTitle,
                        itemContext: _vm.itemContext
                },"overrideComponentId":_vm.trackerType.dataTableEditComponentId},on:{"edit-done":_vm.handleCloseDialog,"cancel":function($event){_vm.dialog = !_vm.dialog}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }